import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const ONBOARDING_GUIDED_TOUR_STORAGE =
  "@sidekick:onboarding-guided-tour-storage";

type OnboardingTourStatus = "idle" | "pending" | "running";

type OnboardingTourState = {
  status: OnboardingTourStatus;
  scheduleTour: () => void;
  startTour: () => void;
  completeTour: () => void;
};

// scheduleTour is only ever called from WelcomeWrapper right after
// onboardingFlow is set, so an already-onboarded user can never reach it.
export const useOnboardingGuidedTourStore = create<OnboardingTourState>()(
  persist(
    (set) => ({
      status: "idle",
      scheduleTour: () =>
        set((state) =>
          state.status === "idle" ? { status: "pending" } : state,
        ),
      startTour: () =>
        set((state) =>
          state.status === "pending" ? { status: "running" } : state,
        ),
      completeTour: () =>
        set((state) => (state.status !== "idle" ? { status: "idle" } : state)),
    }),
    {
      name: ONBOARDING_GUIDED_TOUR_STORAGE,
      version: 1,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
